export var openLocalFileWithNewWindow = function openLocalFileWithNewWindow(file) {
  var url = URL.createObjectURL(file);
  var a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};